import React, { useContext, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { Grid } from "@mui/material";
import { useState } from "react";
import MethodGet from "../../config/Service";
import AuthContext from "../../Context/auth/AuthContext";
import PointsHistoryTable from "./PointsHistoryTable";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function PointsHistory({ open, handleClose }) {
  const { usuario } = useContext(AuthContext);
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setLoading(true); // <--- Aquí
      let url = `/distribucion/historial-puntos/${usuario.id}`;
      MethodGet(url)
        .then((res) => {
          setHistorial(res.data.historial);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error al obtener el historial de puntos:", error);
          setError(error);
          setLoading(false); // No te olvides de apagar el loading también si hay error
        });
    }
  }, [open, usuario.id]);

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "absolute", backgroundColor: "#801F54" }}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={handleClose}
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
              Historial de puntos
            </Typography>
            <Button autoFocus color='inherit' onClick={handleClose}>
              Cerrar
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container spacing={2} sx={{ padding: 2, mt: 10 }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <PointsHistoryTable pointsHistory={historial} />
          </Grid>
        </Grid>
      </Dialog>
    </React.Fragment>
  );
}
